// extracted by mini-css-extract-plugin
export default {"app":"SendLostPassword_app__ic8GM","headerBar":"SendLostPassword_headerBar__xXdwX","view":"SendLostPassword_view__5zlfr"};